// Aparência (P0.8): claro / escuro / igual ao sistema.
import { useEffect, useState } from 'react';
import { resolveTheme, type ThemePref } from '../domain/settings';

const DARK_QUERY = '(prefers-color-scheme: dark)';

function systemPrefersDark(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.(DARK_QUERY).matches;
}

export function applyTheme(theme: 'light' | 'dark', root: HTMLElement = document.documentElement): void {
  root.dataset.theme = theme;
  root.style.colorScheme = theme;
}

/** Aplica o tema no <html> e acompanha o sistema quando a escolha é "Igual ao sistema". */
export function useTheme(pref: ThemePref): 'light' | 'dark' {
  const [systemDark, setSystemDark] = useState(systemPrefersDark);
  useEffect(() => {
    const mq = window.matchMedia?.(DARK_QUERY);
    if (!mq) return;
    const onChange = () => setSystemDark(mq.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);
  const theme = resolveTheme(pref, systemDark);
  useEffect(() => applyTheme(theme), [theme]);
  return theme;
}
